import type { CommunityMemberSelectVariantProps } from "./CommunityMemberSelectCompassComponent";
import { CommunityMemberSelectView } from "./CommunityMemberSelectView";
import { useCommunityMemberCRMSearch } from "./useCommunityMemberCRMSearch";

// ClickHouse CRM-backed variant. Once crm_clickhouse_contacts_search_pickers_enabled
// is fully rolled out, this becomes the only variant and both the legacy and
// contains variants can be deleted.
export const CommunityMemberSelectCRMVariant = (
  props: CommunityMemberSelectVariantProps,
) => {
  const searchState = useCommunityMemberCRMSearch({
    excludeAdmins: props.excludeAdmins,
    filters: props.filters,
    getCommunityMemberText: props.getCommunityMemberText,
    includeInactive: props.includeInactive,
    valueField: props.valueField,
  });

  return <CommunityMemberSelectView {...props} {...searchState} />;
};
